import { createContext } from 'react';

export const initialListFilters = {
    type: null, 
    query : { 
      status : null,
      fullTextQuery: null,
      filters: null,
      from: 0
    }, 
    tableControls: {
      sorter: null,
      pagination: null
    }
}

const AppContext = createContext();
export default AppContext